export enum INVOICE_ACCORDION_ID {
  'CUSTOMER' = 'CUSTOMER',
  'ITEMS' = 'ITEMS',
  'TITLE' = 'TITLE',
  'SCHEDULE' = 'SCHEDULE',
  'EMAIL' = 'EMAIL',
}
